import { Line } from '@ant-design/plots';
import { Props } from './types';
import { Datum } from '@antv/g2plot';

const DemoLine: React.FC<Props> = ({ data }) => {
  const config = {
    data,
    xField: 'month',
    yField: 'value',
    seriesField: 'department',
    yAxis: {
      label: {
        formatter: (v: any) => v,
      },
    },
    point: {
      shape: 'circle',
    },
    style: {
      height: '100%',
      width: '100%',
    },

    legend: {
      layout: undefined,
      position: undefined,

      marker: {
        style: {
          lineWidth: 10,
          lineHeight: 10,
        },
      },
    },

    tooltip: {
      formatter: (datum: Datum) => {
        return {
          name: `<span style="font-size: 16px">${datum.department}</span>`,
          value: `<span style="font-size: 18px">${datum.value}</span>`,
        };
      },
    },
  };

  return <Line {...config} />;
};

export default DemoLine;
